import { render, staticRenderFns } from "./NavbarNavReleaseNotesButton.vue?vue&type=template&id=379d50b8&scoped=true&"
import script from "./NavbarNavReleaseNotesButton.vue?vue&type=script&lang=js&"
export * from "./NavbarNavReleaseNotesButton.vue?vue&type=script&lang=js&"
import style0 from "./NavbarNavReleaseNotesButton.vue?vue&type=style&index=0&id=379d50b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d50b8",
  null
  
)

export default component.exports